/*
 * @Author: Dong
 * @Date: 2022-05-07 11:43:44
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-06-11 13:28:06
 */
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { getBackupList } from 'root/services/syncBack';
import { List } from 'sup-ui';
import messages from '../messages';
import styles from './Table.less';

interface dataSourceType {
  filePath: string;
  fileName: string;
  description: string;
  version: string;
}

const Table = (props: any, ref: React.Ref<unknown> | undefined) => {
  const intl = useIntl();

  const [dataSource, setDataSource] = useState<dataSourceType[]>([]);
  const [selectedItem, setSelectedItem] = useState<string>();

  useImperativeHandle(ref, () => ({
    validateFields: validateFields, // 校验数据
  }));

  const columns = useMemo(() => {
    return [
      {
        title: intl.formatMessage(messages.serial),
        dataIndex: 'serial',
        width: 40,
      },
      {
        title: intl.formatMessage(messages.file),
        width: 160,
        dataIndex: 'fileName',
      },
      {
        title: intl.formatMessage(messages.version),
        width: 160,
        dataIndex: 'version',
      },
      {
        title: intl.formatMessage(messages.desc),
        dataIndex: 'description',
      },
    ];
  }, []);

  useEffect(() => {
    getBackupList().then((res) => {
      const { data } = res;
      data.forEach((item: any, i: number) => {
        item.serial = `${i + 1}`;
      });
      setDataSource(data);
    });
  }, []);

  const validateFields = (fn: (arg0: boolean, arg1: any) => void) => {
    if (!fn) return;

    const isError = !selectedItem;

    fn(isError, { taskIds: selectedItem });
  };

  // 选中
  const handleSelect = (fileName: string) => {
    setSelectedItem(fileName);
  };

  const renderHeader = useMemo(() => {
    return (
      <>
        {columns.map((column) => {
          return (
            <div key={column.dataIndex} style={{ width: column.width }} title={column.title}>
              {column.title}
            </div>
          );
        })}
      </>
    );
  }, [columns]);

  return (
    <List
      className={styles.list}
      header={renderHeader}
      bordered
      dataSource={dataSource}
      renderItem={(item: any) => (
        <List.Item
          className={`${selectedItem === item.fileName ? styles.selectedItem : ''}`}
          onClick={() => handleSelect(item.fileName)}
        >
          {columns.map((column) => {
            const content = item[column.dataIndex];
            return (
              <div key={column.dataIndex} style={{ width: column.width }} title={content}>
                {content}
              </div>
            );
          })}
        </List.Item>
      )}
    />
  );
};

export default forwardRef(Table);
